export default __webpack_public_path__ + "static/zakup-0c93ba1e7981722cc24dc7d34dee5936.webp";